(function () {
  'use strict';

  angular.module('app').controller('EntityInbodyController', EntityInbodyController);

  EntityInbodyController.$inject = ['$scope', 'constants', 'utilService', 'EntityService', 'ModalService'];

  function EntityInbodyController($scope, constants, utilService, EntityService, ModalService) {
    const vm = this;
    vm.spinner = false;
    vm.inbodyDetails = {
      allowNonInbodyUsers: false,
      entryFields: {
        weight: true,
        gender: true,
        height: true,
        percent_body_fat: true,
        poundOfFat: true,
        lbm: true,
        navel: false,
        thigh: false,
        bicep: false,
        chest: false,
        hip: false,
        icw: false,
        ecw: false,
        tbw: false,
        dlm: false,
        smm: false,
        bmr: false,
        neck: false,
        phaseAngle: false,
        measureUnit: 'INCHES'
      },
      supportedInbodyTypes: {
        inbody_270: false,
        inbody_370: false,
        inbody_380H: false,
        inbody_570: false,
        inbody_580H: false,
        inbody_770: false,
        inbody_970: false
      }
    };
    vm.inbodyTypes = constants.inbodyTypes;
    vm.dataEntryFields = angular.copy(constants.inbodyData);
    vm.measureUnits = constants.measureUnits;
    vm.ENTITY_TYPES = constants.enums.entityTypes;
    vm.isSuperAdmin = utilService.getIsSuperAdmin();
    vm.availablePaidServiceTypes = [];
    vm.entityType = '';

    vm.getInbodyDetails = getInbodyDetails;
    vm.getIsInbodyTypeCardValid = getIsInbodyTypeCardValid;
    vm.getIsInbodySelected = getIsInbodySelected;
    vm.onOptionalCheckboxChange = onOptionalCheckboxChange;
    vm.onSubmit = onSubmit;
    vm.saveInbodyDetails = saveInbodyDetails;
    vm.saveSerialNumbers = saveSerialNumbers;

    vm.$onInit = () => {
      vm.getInbodyDetails();
      vm.entityType = $scope.entityType;
    };

    function getInbodyDetails() {
      vm.spinner = true;
      EntityService.getInbodyDetails($scope.entityId)
        .then(res => {
          if (res.status === 200) {
            Object.assign(vm.inbodyDetails, res.data);
          }
        })
        .finally(() => vm.spinner = false);
    }

    function getIsInbodyTypeCardValid() {
      if (vm.inbodyDetails.allowNonInbodyUsers) {
        return true;
      } else {
        return vm.getIsInbodySelected();
      }
    }

    function getIsInbodySelected() {
      return Object.keys(vm.inbodyDetails.supportedInbodyTypes)
        .filter(key => key !== 'serialNumber')
        .some(key => vm.inbodyDetails.supportedInbodyTypes[key]);
    }

    function onOptionalCheckboxChange() {
      if (!vm.inbodyDetails.entryFields.icw || !vm.inbodyDetails.entryFields.ecw) {
        vm.inbodyDetails.entryFields.tbw = false;
      }
    }

    function onSubmit() {
      vm.saveInbodyDetails();
    }

    function saveInbodyDetails() {
      vm.spinner = true;
      EntityService.saveInbodyDetails($scope.entityId, vm.inbodyDetails)
        .then(res => {
          if (res.status === 200) {
            ModalService.savedChanges();
          }
        })
        .finally(() => vm.spinner = false);
    }

    function saveSerialNumbers() {
      const body = [vm.inbodyDetails.supportedInbodyTypes.serialNumber];
      vm.spinner = true;
      EntityService.saveInbodySerialNumbers($scope.entityId, body)
        .then(res => {
          if (res.status === 200) {
            ModalService.savedChanges();
          }
        })
        .finally(() => vm.spinner = false);
    }
  }

})();
